<p>inventory-purchase works!</p>
